define([
    "dojo/_base/declare",
    "csi/view/ToolbarPluginToggleButton"
], function(declare,ToolbarPluginToggleButton) {

    return declare(ToolbarPluginToggleButton, {

        postMixInProperties: function() {
            this.inherited(arguments);
            this.defAction.classController = "csi/view/RefreshController";
        },

        isToggledInitially: function(/*Context?*/ctx) {
            // summary: determine toggle status of action
            return this.getView().get("showDetails");
        },

        onChange: function(/*Object*/value, /*Action*/action) {
            // summary: user callback for when widget value changes
            this.getView().set("showDetails", value);
            this.inherited(arguments);
        }
    });
});